export const BrandMark = ({ className = "h-9 w-9", title = "Triactiva" }) => (
  <img
    src="/brand/triactiva-mark.png"
    alt={title}
    className={`object-contain ${className}`}
    draggable={false}
  />
);

/** Logo completo (isotipo + wordmark + tagline) */
export const BrandLockupImage = ({ className = "h-12 w-auto", title = "Triactiva" }) => (
  <img
    src="/brand/triactiva-lockup.png"
    alt={title}
    className={`object-contain object-left ${className}`}
    draggable={false}
  />
);

/** Isotipo + texto HTML (mejor en fondos claros / tamaños pequeños) */
export const BrandLockup = ({ compact = false, invert = false, useImage = false }) => {
  if (useImage) {
    return <BrandLockupImage className={compact ? "h-10 w-auto max-w-[220px]" : "h-14 w-auto max-w-[280px]"} />;
  }
  return (
    <div className="flex items-center gap-2.5">
      <BrandMark className={compact ? "h-8 w-8" : "h-10 w-10"} />
      <div className="min-w-0">
        <p className={`font-display text-xl font-extrabold tracking-tight ${invert ? "text-white" : "text-ink"}`}>
          Triactiva
        </p>
        {!compact && (
          <p className={`text-[10px] font-semibold uppercase tracking-[0.14em] ${invert ? "text-white/70" : "text-stone-500"}`}>
            Entrena · Nutre · Recupérate
          </p>
        )}
      </div>
    </div>
  );
};
